import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {CatalogueModule} from "../catalogue/catalogue.module";
import {LocalisationModule} from "../localisation/localisation.module";
import {NavLayoutComponent} from "./nav-layout/nav-layout.component";
import {HomePageComponent} from "./home-page/home-page.component";
import {AccountModule} from "../accounts/account.module";
import {PricingModule} from "../pricing/pricing.module";
import {PosModule} from "../pos/pos.module";
import {CustomersModule} from "../customers/customers.module";
import {EmployeeModule} from "../employee/employee.module";
import {SystemModule} from "../system/system.module";
import {SaleModule} from "../sale/sale.module";
import {ContactModule} from "../contact/contact.module";
import {CustomObjectModule} from "../custom-objects/custom-object.module";
import {ReportsModule} from "../reports/reports.module";
import {BiModule} from "../bi/bi.module";
import {FrameworkModule} from "../framework/framework.module";
import {StockModule} from "../stock/stock.module";
import {WebOrderingModule} from "../web-ordering/web-ordering.module";
import {UserProfileModule} from "../user-profile/user-profile.module";
import {NotificationModule} from "../notification/notification.module";
import {HelpModule} from "../help/help.module";
import {OrderProcessingModule} from "../order-processing/order-processing.module";
import {PosSharedModule} from "../pos/pos.shared.module";
import {SystemSharedModule} from "../system/system.shared.module";
import {ApiModule} from "../api/api.module";
import {ApiSharedModule} from "../api/api.shared.module";

/**
 * The Main Module is the top level for all the Business Feature Modules.
 *
 * All Feature Modules are imported into this module. It also declares some page layout Components.
 *
 * The Main has its own routing (main.routing.ts) which manages routes to various feature Page Components that
 * are included in the imported modules.
 *
 * See https://angular.io/guide/ngmodule#feature-modules
 */
@NgModule({
    imports: [
        CatalogueModule,
        OrderProcessingModule,
        LocalisationModule,
        SharedModule,
        AccountModule,
        PricingModule,
        PosModule,
        CustomersModule,
        FrameworkModule,
        EmployeeModule,
        SystemModule,
        SaleModule,
        ContactModule,
        CustomObjectModule,
        ContactModule,
        StockModule,
        ReportsModule,
        BiModule,
        WebOrderingModule,
        UserProfileModule,
        NotificationModule,
        HelpModule,
        PosSharedModule,
        SystemSharedModule,
        ApiModule,
        ApiSharedModule
    ],
    declarations: [
        HomePageComponent,
        NavLayoutComponent
    ]
})
export class MainModule {
}
